import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Box, IconButton, Tooltip, Typography, useMediaQuery } from '@mui/material';
import { ArrowDropDown, ArrowRight, Circle } from '@mui/icons-material';

import { setTableRowCount2 } from '../../../redux/reducers/DashboardSlice';
import { useDispatch, useSelector } from 'react-redux';
import { MoneyFormatv3, MoneyFormatUniversal } from '../../../library/MoneyFormat';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../../../components/snackBar/snakbar';

import { API, graphqlOperation } from 'aws-amplify';

import { useNavigate } from 'react-router-dom';

import { elementScroll, useWindowVirtualizer } from '@tanstack/react-virtual';
import { getAccountGroupMaster, getPartyMasterCustom, updateAccountGroupMaster, getPartyMasterAccountWiseCustom } from '../../../graphql';
import { dashboardApi } from '../../../redux/apis/dashboardApi';
import { useDeleteAccountMasterMutation } from '../../../features/AccountsAndGroups/api/accountMaster.api';
import { useDeleteAccountGroupMasterMutation } from '../../../redux/apis/accountGroupMaster.api';
import { useThemes } from '../../../components/Theme/theme';
import { settingsClose } from '../../../redux/reducers/companySkipSave';
import AddNewPartyModal from '../../PrimeFigma/Modals/AddNewPartyModal';
import { handleFreeze } from '../../../utils/common';
import CreateAndEditLedger from '../../../components/modals/CreateAndEditLedger';
import CreateAndEditGroupModal from '../../../components/modals/CreateAndEditGroupModal';
import DeleteLedgerGroup from '../../../components/modals/DeleteLedgerGroup';
import ActionButtons from '../../../components/Buttons/ActionButtons';

import './style.css';
import VoucherBTNnew from '../../../components/Buttons/VoucherBTNnew';
import { LedgerModal, useLedgerModalHandle } from '../../../features/AccountsAndGroups';

const buttonStyle = {
  borderRadius: 10,
  color: '#297179',
  backgroundColor: '#FFF',
  fontFamily: 'overpass',
  fontWeight: '700',
  fontSize: 15,
  paddingTop: 0.5,
  paddingBottom: 0.5,
  PaddingLeft: 1,
  paddingRight: 1,
  marginBottom: 1,
};

function easeInOutQuint(t) {
  return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
}

function BalanceSheetTableNew({
  heading,
  rows,
  expandButtonClicked,
  hideBSToggleClicked,
  hideAmount,
  mainTotal,
  setAccountID,
  setNewLedgerResponse,
  newLedgerAccountID,
  openingBalanceDiff,
  options,
  refetchDb,
  headColor,
  setBackdropOpen,
  startTimeStamp,
  endTimeStamp,
}) {
  const { theme } = useThemes();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const parentRef = useRef();
  const [openModal, setOpenModal] = useState({
    groupModal: false,
    ledgerModal: false,
    editModal: false,
    partyModal: false,
    editGroupModal: false,
    deleteModal: false,
    transcationModal: false,
    receiptModal: false,
    journalModal: false,
    paymentModal: false,
    debitNoteModal: false,
    creditNoteModal: false,
    salesModal: false,
    purchaseModal: false,
  });
  const [expandedRows, setExpandedRows] = useState([]);
  const [emptyRowCount, setEmptyRowCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [groupName, setGroupName] = useState('');
  const [updatedata, setUpdatedata] = useState('');
  const [deleteId, setdeleteId] = useState('');
  // const [total, setTotal] = useState(0);
  const [partyDetails, setPartyDetails] = useState(null);
  const [newPartyID, setNewPartyID] = useState(null);
  const [ledgerData, setLedgerData] = useState('');
  const [gstData, setGstData] = useState({});
  const [data, setData] = useState(rows);
  const [emptyRows, setEmptyRows] = useState(0);

  const balanceSheetReducer = useSelector((state) => state.DashboardDataReducer.balanceSheet);

  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);

  const isVertical = balanceSheetReducer?.isVertical;

  const { saveSkipStatus } = useSelector((state) => state.companySipSaveReducer);

  const memoizedRows = useMemo(() => data, [data]);

  const handleOpenModal = (key) => {
    if (key in openModal) {
      setOpenModal((prev) => ({ ...prev, [key]: !prev[key] }));
    }
  };

  const { openLedgerModal, closeLedgerModal, ledgerModalParams } = useLedgerModalHandle();

  useEffect(() => {
    try {

      if(expandButtonClicked){
          let filteredRows = [...rows];

      if (!Array.isArray(rows)) {
        setData([]);
        setExpandedRows([]);
        return;
      }

      if (hideBSToggleClicked) {
        filteredRows = filteredRows.filter((item) => item.category === 'group' || item?.balance !== 0);
      }

      setData(filteredRows);

      const expanded = filteredRows
        .filter((row) => row && row?.category === 'group' && row?.id !== undefined)
        .map((row) => ({ id: row?.id, isExpand: true }));

      setExpandedRows(expanded);


      }else{
       setExpandedRows(rows.filter((row) => row.category === 'group').map((row) => ({ id: row.id, isExpand: false })));
        const collapseData = rows.filter((item) => item.category === 'group' && item.path.split('/').length === 4);
        setData(collapseData);
      }
      
    } catch (error) {
      setData([]);
      setExpandedRows([]);
    }
  }, [rows, hideBSToggleClicked,expandButtonClicked]);

  useEffect(() => {
    if (rows?.length > 0) {
      if (expandButtonClicked) {
        handleExpandAll();
      } else {
        handleCollapseAll();
      }
    }
  }, [expandButtonClicked]);

  const handleExpandAll = () => {
    const filteredData = hideBSToggleClicked ? rows.filter((item) => item.category === 'group' || item?.balance !== 0) : rows;
    setExpandedRows(filteredData.filter((row) => row.category === 'group').map((row) => ({ id: row.id, isExpand: true })));
    setData(filteredData);
  };

  const handleCollapseAll = () => {
    setExpandedRows(rows.filter((row) => row.category === 'group').map((row) => ({ id: row.id, isExpand: false })));
    const collapseData = data.filter((item) => item.category === 'group' && item.path.split('/').length === 4);
    setData(collapseData);
  };

  const { table1, table2 } = useSelector((state) => state.DashboardDataReducer.balanceSheet.tableRowCount);

  useEffect(() => {
    if (data.length) {
      const table_key = heading === 'Liabilities' ? 'table1' : 'table2';
      dispatch(setTableRowCount2({ key: table_key, count: data.length }));
    }
  }, [data]);

  useEffect(() => {
    const compareTable = heading === 'Liabilities' ? table2 : table1;
    const maxRowCount = Math.max(data.length, compareTable);
    setEmptyRows(maxRowCount - data.length);
  }, [data, table1, table2]);

  

  const fetchPartyMasterData = async (AccountsID) => {
    try {
      const response = await API.graphql(
        graphqlOperation(getPartyMasterAccountWiseCustom, {
          accountsid: AccountsID,
        })
      );

      return response?.data?.getPartyMasterAccountWise[0];
    } catch (error) {
      console.error('Error fetching party master account data:', error);
      throw error;
    }
  };

  useEffect(() => {
    if (newPartyID) findNewPartyAccountId();
  }, [newPartyID]);

  async function findNewPartyAccountId() {
    try {
      const response = await API.graphql(
        graphqlOperation(getPartyMasterCustom, {
          partyid: newPartyID,
        })
      );
      if (selectedRow?.action === 'create') {
        setNewLedgerResponse([response?.data?.getPartyMaster[0]?.accountsid + 'ledger']);
      } else {
        setNewLedgerResponse([]);
      }
      refetchDb && refetchDb();
      setNewPartyID(null);
    } catch (error) {
      console.error('Error fetching new party account data:', error);
    }
  }

  useEffect(() => {
    if (updatedata !== '') {
      setBackdropOpen(true);
      editData();
      setUpdatedata('');
    }
  }, [updatedata]);

  useEffect(() => {
    if (deleteId !== '') {
      setBackdropOpen(true);
      deleteLedgers();
      setdeleteId('');
    }
  }, [deleteId]);

  const [deleteAccountGroupMaster] = useDeleteAccountGroupMasterMutation();
  const [deleteAccountMaster] = useDeleteAccountMasterMutation();

  async function deleteLedgers() {
    try {
      setBackdropOpen(true);
      if (deleteId.category === 'group') {
        const response = await deleteAccountGroupMaster({
          accountgroupid: deleteId?.id,
        });

        if (response?.data?.statuscode === 'Error') {
          showWarningSnackbar(response?.data?.statusmessage);
        } else {
          showSuccessSnackbar('Group Deleted');
        }
      } else if (deleteId.category === 'ledger') {
        const response = await deleteAccountMaster({
          accountsid: deleteId?.id,
        });

        const { statuscode, statusmessage } = response?.data?.deleteAccountMaster;

        if (statuscode && statusmessage) {
          if (statuscode === 'Error') {
            if (statusmessage.includes('Transactions Already Recorded')) {
              showWarningSnackbar('Cannot delete ledger account : Transactions exists in the current year');
            } else {
              showWarningSnackbar(statusmessage);
            }
          } else if (statuscode === 'Success') {
            showSuccessSnackbar('Ledger Deleted');
          } else {
            showWarningSnackbar(statusmessage || 'Something went wrong while deleting ledger');
          }
        } else {
          showErrorSnackbar('Error occurred while deleting ledger');
        }
      }

      dispatch(dashboardApi.util.invalidateTags(['dashboard']));
    } catch (error) {
      console.error('Error deleting ledger/group:', error);
      showErrorSnackbar('An error occurred while deleting');
    } finally {
      setBackdropOpen(false);
    }
  }
  async function editData() {
    if (updatedata.rowDetails.category == 'group') {
      try {
        const resGroup = await API.graphql(
          graphqlOperation(getAccountGroupMaster, {
            AccountGroupID: updatedata.id,
          })
        );
        if (resGroup?.data?.getAccountGroupMaster !== null) {
          const UpdateDetails = resGroup?.data?.getAccountGroupMaster;
          const updateInput = {
            AccountGroupID: updatedata.id,
            AccountGroupName: updatedata.NewEditName,
            DisplayOrderNumber: UpdateDetails?.DisplayOrderNumber,
            AccountParentGroupID: updatedata?.NewGroupEditNameID === updatedata?.id ? '' : updatedata?.NewGroupEditNameID,
            AccountTypeCD: UpdateDetails?.AccountTypeCD,
            EnteredTimeStamp: UpdateDetails?.EnteredTimeStamp,
            ExpiredTimeStamp: UpdateDetails?.ExpiredTimeStamp,
            Is_Active: UpdateDetails?.Is_Active,
          };
          const resUpdateGroup = await API.graphql(
            graphqlOperation(updateAccountGroupMaster, {
              updateAccountGroupMasterInput: updateInput,
            })
          );
          if (resUpdateGroup.data.updateAccountGroupMaster.StatusCode === null) {
            showSuccessSnackbar('Group Updated');
            setNewLedgerResponse([]);
            setBackdropOpen(false);
          } else {
            showWarningSnackbar(resUpdateGroup.data.updateAccountGroupMaster.StatusMessage);
            setBackdropOpen(false);
          }
        } else {
          showWarningSnackbar('Something went Wrong! Please Try Again');
          setBackdropOpen(false);
        }
      } catch (error) {
        console.log(error);
        setBackdropOpen(false);
      }
    }
  }

 

  const toggleExpandRow = useCallback(
    (id) => {
      setData((prevRows) => {
        const result = [...prevRows];
        const isRowExpanded = expandedRows.some((ele) => ele.id === id && ele.isExpand);

        if (isRowExpanded) {
          // Collapse Logic
          const collapseIDs = data
            .filter((item) => item?.path?.split('/')?.includes(String(id)) && item.category === 'group')
            .map((item) => item.id);

          const updatedRows = result.filter(
            (item) => !item.path?.split('/')?.includes(String(id)) || (item.id === id && item.category === 'group')
          );

          setExpandedRows((prev) => prev.map((row) => (collapseIDs.includes(row.id) ? { ...row, isExpand: false } : row)));

          return updatedRows;
        } else {
          // Expand Logic
          const filteredSource = hideBSToggleClicked ? rows.filter((item) => item.category === 'group' || item.balance !== 0) : rows;

          const children = filteredSource.filter((item) => item?.parent === id);
          const index = result.findIndex((item) => item?.id === id);

          if (index !== -1) {
            result.splice(index + 1, 0, ...children);
          }

          setExpandedRows((prev) => prev.map((row) => (row.id === id ? { ...row, isExpand: true } : row)));

          return result;
        }
      });
    },
    [rows, expandedRows, hideBSToggleClicked, data]
  );

  const scrollingRef = React.useRef();

  const scrollToFn = React.useCallback((offset, canSmooth, instance) => {
    const duration = 1000;
    const start = parentRef.current?.scrollTop || 0;
    const startTime = (scrollingRef.current = Date.now());

    const run = () => {
      if (scrollingRef.current !== startTime) return;
      const now = Date.now();
      const elapsed = now - startTime;
      const progress = easeInOutQuint(Math.min(elapsed / duration, 1));
      const interpolated = start + (offset - start) * progress;

      if (elapsed < duration) {
        elementScroll(interpolated, canSmooth, instance);
        requestAnimationFrame(run);
      } else {
        elementScroll(interpolated, canSmooth, instance);
      }
    };

    requestAnimationFrame(run);
  }, []);

  const listRef = React.useRef(null);

  const rowVirtualizer = useWindowVirtualizer({
    count: memoizedRows.length,
    estimateSize: () => 35,
    overscan: 50,
    scrollToFn,
    scrollMargin: listRef.current?.offsetTop ?? 0,
  });

  const emptyRowVirtualizer = useWindowVirtualizer({
    count: emptyRows,
    estimateSize: () => 35,
    overscan: 50,
  });

  const handleTranscationModal = useCallback((category, id, name) => {
    if (id === 'p2') {
      navigate('/?active=ProfitAndLoss');
      return;
    }
    // Check if this is a closing stock entry based on name
    if (category === 'ledger' && name && (name.toLowerCase().includes('closing stock') || name.toLowerCase().includes('inventory'))) {
      navigate('/reports', {
        state: {
          startTimeStamp,
          endTimeStamp,
          period: `${startTimeStamp && endTimeStamp ? `${new Date(startTimeStamp * 1000).toLocaleDateString()} - ${new Date(endTimeStamp * 1000).toLocaleDateString()}` : 'Current Period'}`
        }
      });
      return;
    }
    if (category === 'ledger') {
      setAccountID(id);
    }
  }, [startTimeStamp, endTimeStamp]);

  const handleSelectRow = useCallback((row) => {
    setSelectedRow(row);

    if (Freeze === 1) return handleFreeze();

    const { modal, category, action, id, parent, name } = row || {};

    if (modal === 'ledger') {
      openLedgerModal({
        groupId: category === 'group' ? id : parent,
        accountId: action === 'edit' ? id : '',
        title: action === 'edit' ? name : '',
        filterAccountTypeCd: 'BS',
        restrictedflag: row?.restrictedflag,
      });
    } else {
      handleOpenModal(action === 'delete' ? 'deleteModal' : 'groupModal');
    }
  }, []);

  const handleLedgerModal = ({ accountsId }) => {
    setNewLedgerResponse(selectedRow?.action === 'create' ? accountsId + 'ledger' : null);
    setSelectedRow(null);
  };

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Box sx={{ boxSizing: 'border-box' }}>
        <Box sx={{ display: 'flex' }}>
          <Box
            sx={{
              width: isSmallScreen ? '60%' : '70%',
              // width: isSmallScreen ? "300px" : "75%",
              borderTopLeftRadius: '10px',
              borderTopRightRadius: '10px',
              height: '45px',
              backgroundColor: headColor,
              borderRight: '4px solid',
              borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? '#26262F' : '#ffffff',
              '.button-container': {
                display: 'none',
              },
              '.hover-default': {
                display: 'none',
              },
              '&:hover': {
                '.button-container': {
                  display: 'block',
                },
                '.hover-default': {
                  display: 'block',
                },
              },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                px: 2,
                height: '100%',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Typography variant="h1" sx={{ color: '#fff', fontSize: { xs: '14px', sm: '16px' } }}>
                {heading}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              width: isSmallScreen ? '40%' : '30%',
              borderTopLeftRadius: { xs: '0px', sm: '10px' },
              borderTopRightRadius: '10px',
              height: '45px',
              backgroundColor: headColor,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderTop: { xs: '1px solid rgba(255,255,255,0.2)', sm: 'none' },
            }}
          >
            <Typography variant="h1" sx={{ color: '#fff', fontSize: { xs: '14px', sm: '16px' } }}>
              Amount
            </Typography>
          </Box>
        </Box>

        <Box ref={listRef}>
          <Box
            sx={{
              height: `${rowVirtualizer.getTotalSize()}px`,
              borderRight: '1px solid #C0C0C0',
              borderLeft: '1px solid #C0C0C0',
              position: 'relative',
            }}
          >
            {memoizedRows.length > 0 &&
              rowVirtualizer.getVirtualItems().map((virtualRow) => {
                const item = memoizedRows[virtualRow.index];
                const isExpand = expandedRows.find((ele) => ele.id === item?.id)?.isExpand || false;
                let multiplyBy = isSmallScreen ? 5 : 10;
                const level = item?.depth * multiplyBy;
                return (
                  <div
                    key={virtualRow.key}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: `${virtualRow.size}px`,
                      borderBottom: '1px solid rgb(218, 217, 217)',
                      transform: `translateY(${virtualRow.start - rowVirtualizer.options.scrollMargin}px)`,
                    }}
                  >
                    <div class="box-container">
                      <Box
                        sx={{
                          width: isSmallScreen ? '60%' : '70%',
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          borderRight: '4px solid ',
                          borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? theme.palette.primary.black : '#eef0f0',
                          '.button-container': {
                            display: 'none',
                          },
                          '.hover-default': {
                            display: 'none',
                          },
                          '&:hover': {
                            '.button-container': {
                              display: 'flex',
                            },
                            '.hover-default': {
                              display: isSmallScreen ? 'none' : 'block',
                            },
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            height: '100%',
                            paddingLeft: `${level}px`,
                            width: isSmallScreen ? '160px' : '500px',
                            // maxWidth:"130px",
                            // overflow: isSmallScreen ? "auto" : "hidden",
                            overflow: { xs: 'auto', xl: 'hidden' },
                            textOverflow: isSmallScreen ? 'normal' : 'ellipsis',
                            whiteSpace: isSmallScreen ? 'nowrap' : 'nowrap',
                            // backgroundColor:"black"
                            scrollbarWidth: 'none',
                            // Hide scrollbar - IE & Edge
                            msOverflowStyle: 'none',

                            // Hide scrollbar - Chrome, Safari
                            '&::-webkit-scrollbar': {
                              display: 'none',
                            },
                          }}
                        >
                          {item?.category === 'group' ? (
                            <IconButton
                              aria-label={isExpand ? 'collapse' : 'expand'}
                              size="small"
                              onClick={() => toggleExpandRow(item?.id)}
                              style={{ padding: 0, margin: 0 }}
                            >
                              {isExpand ? <ArrowDropDown /> : <ArrowRight />}
                            </IconButton>
                          ) : (
                            <IconButton size="small" style={{ padding: 0, margin: 0 }}>
                              <Circle
                                sx={{
                                  width: 10,
                                  height: 10,
                                  color: '#ee5b2b',
                                  marginRight: 1.5,
                                  marginLeft: 0.8,
                                }}
                              />
                            </IconButton>
                          )}

                          <Typography
                            onClick={item?.category === 'ledger' ? () => handleTranscationModal(item?.category, item.id, item.name) : undefined}
                            sx={{
                              cursor: item?.category === 'ledger' ? 'pointer' : 'default',
                              fontSize: { xs: 12, lg: 13 },
                              fontWeight: item?.category === 'group' ? 'bold' : 0,
                              color:
                                item?.category === 'group'
                                  ? theme.palette.primary.main
                                  : theme?.palette?.TmId.id.toString().includes('9')
                                  ? '#fff'
                                  : '#000000',
                              maxWidth: { lg: '90%' },
                              whiteSpace: { lg: 'nowrap' },
                              overflow: { lg: 'hidden' },
                              textOverflow: { lg: 'ellipsis' },
                            }}
                          >
                            <Tooltip title={item?.name}>{item?.name}</Tooltip>
                          </Typography>

                          {item?.restrictedflag === 1 && (
                            <Typography
                              className="hover-default"
                              textAlign="center"
                              variant="body2"
                              fontStyle="italic"
                              sx={{
                                px: 1,
                                color: '#818694',
                                fontSize: { xs: 10, lg: 15 },
                              }}
                            >
                              {item?.category === 'ledger' ? 'Default A/C' : 'Default Group'}
                            </Typography>
                          )}

                          {newLedgerAccountID === (item?.category === 'group' ? item?.id : item?._id) && (
                            <Box
                              sx={{
                                backgroundColor: '#FF004D',
                                color: '#FFF',
                                borderRadius: '10px',
                                display: 'flex',
                                alignItems: 'center',
                                px: 2,
                                mx: 1,
                              }}
                            >
                              <Typography variant="caption"> New</Typography>
                            </Box>
                          )}
                        </Box>

                        <ActionButtons
                          key={virtualRow?.index}
                          item={item}
                          handleSelectRow={handleSelectRow}
                          isSmallScreen={isSmallScreen}
                          theme={theme}
                          bgcolor={theme.palette.primary.main}
                        />
                      </Box>

                      <Box
                        sx={{
                          width: isSmallScreen ? '40%' : '30%',
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'end',
                        }}
                      >
                        <Typography
                          sx={{
                            px: 1,
                            fontSize: { xs: 10, lg: 13 },
                            fontWeight: item?.category === 'group' ? 'bold' : 0,
                            color:
                              item?.category === 'group'
                                ? theme.palette.primary.main
                                : theme?.palette?.TmId.id.toString().includes('9')
                                ? '#fff'
                                : '#000000',
                          }}
                        >
                          {!(hideAmount && item?.category !== 'ledger') && (
                            <Tooltip title={MoneyFormatv3(Number(item?.balance))}>₹ {MoneyFormatv3(item?.balance)}</Tooltip>
                          )}
                        </Typography>
                      </Box>
                    </div>
                  </div>
                );
              })}
          </Box>
        </Box>

        {!isVertical && (
          <div>
            <div
              className="virtual-box"
              style={{
                height: `${emptyRowVirtualizer.getTotalSize()}px`,
              }}
            >
              {emptyRowVirtualizer.getVirtualItems().map((virtualemptyRow) => {
                return (
                  <div
                    key={virtualemptyRow.key}
                    ref={virtualemptyRow.measureRef}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      height: `${virtualemptyRow?.size}px`,
                      borderBottom: '1px solid rgb(218, 217, 217)',
                      transform: `translateY(${virtualemptyRow.start}px)`,
                    }}
                  >
                    <div
                      className="emptyrow-cell-1"
                      style={{
                        borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? theme.palette.primary.black : '#eef0f0',
                        width: '70%',
                      }}
                    ></div>

                    <div className="emptyrow-cell-2" style={{ width: '30%' }}></div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {openingBalanceDiff &&
          (() => {
            const liabilitiesCondition = openingBalanceDiff?.credit > 0;
            const assetsCondition = openingBalanceDiff?.debit > 0;
            const balance = liabilitiesCondition ? openingBalanceDiff?.credit : openingBalanceDiff?.debit;

            return (
              <Box
                sx={{
                  display: 'flex',
                  borderRight: '1px solid #C0C0C0',
                  borderBottom: '0.9px solid #C0C0C0',
                  borderLeft: '1px solid #C0C0C0',
                  height: '37px',
                  color: 'red',
                }}
              >
                <Box
                  sx={{
                    width: isSmallScreen ? '60%' : '70%',
                    borderRight: '4px solid',
                    borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? theme.palette.primary.black : '#eef0f0',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      px: 2,
                      height: '100%',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    {((heading === 'Liabilities' && liabilitiesCondition) || (heading === 'Assets' && assetsCondition)) && (
                      <Typography variant="h1" sx={{ fontSize: { xs: 12, lg: 16 } }}>
                        {openingBalanceDiff.name}
                      </Typography>
                    )}
                  </Box>
                </Box>
                <Box
                  sx={{
                    width: isSmallScreen ? '40%' : '30%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'end',
                  }}
                >
                  {((heading === 'Liabilities' && liabilitiesCondition) || (heading === 'Assets' && assetsCondition)) && (
                    <Typography variant="h1" sx={{ px: 1, fontSize: { xs: 12, lg: 16 } }}>
                      <Tooltip title={MoneyFormatv3(Number(balance))}>₹ {MoneyFormatv3(balance)}</Tooltip>
                    </Typography>
                  )}
                </Box>
              </Box>
            );
          })()}

        <Box
          sx={{
            display: 'flex',
            height: '37px',
            borderRight: '1px solid #C0C0C0',
            borderBottom: '1px solid #C0C0C0',
            borderLeft: '1px solid #C0C0C0',
            backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? '#373a36' : theme?.palette?.bodyGray.tertiary,
          }}
        >
          <Box
            sx={{
              width: isSmallScreen ? '60%' : '70%',
              borderRight: '4px solid',
              borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? '#26262F' : '#ffffff',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                px: 2,
                height: '100%',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Typography variant="h1" sx={{ fontSize: { xs: 15, lg: 16 } }}>
                Total
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              width: isSmallScreen ? '40%' : '30%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end',
            }}
          >
            <Tooltip title={MoneyFormatv3(Number(mainTotal))}>
              <Typography variant="h1" sx={{ px: 1, fontSize: { xs: 12, lg: 16 } }}>
                ₹ {MoneyFormatv3(Number(mainTotal))}
              </Typography>
            </Tooltip>
          </Box>
        </Box>
      </Box>

      <LedgerModal {...ledgerModalParams} onSave={handleLedgerModal} onClose={closeLedgerModal} />

      {openModal.deleteModal && (
        <DeleteLedgerGroup
          open={openModal.deleteModal}
          setOpen={() => handleOpenModal('deleteModal')}
          setdeleteId={setdeleteId}
          selectedRow={selectedRow}
          setsuccessSnakbar={showSuccessSnackbar}
        />
      )}

      {openModal.groupModal && (
        <CreateAndEditGroupModal
          open={openModal.groupModal}
          setOpen={() => handleOpenModal('groupModal')}
          groupId={selectedRow?.id}
          selectedRow={selectedRow}
          action={selectedRow?.action}
          setSelectedRow={setSelectedRow}
          setNewLedgerResponse={setNewLedgerResponse}
          page={'Dashboard'}
          setNewPartyID={setNewPartyID}
          tab={'BalanceSheet'}
        />
      )}
    </>
  );
}

export default memo(BalanceSheetTableNew);
